// column lineage with cancellation

import { columnLineage, showInfoNotification, telemetryEvents } from "./api";

export enum CllEvents {
  CANCEL = "cancel",
  END = "end",
  START = "start",
}

export class CLL {
  static isCancelled = false;
  static inProgress = false;
  static linkCount = 0;

  static onCancel() {
    CLL.isCancelled = true;
    CLL.inProgress = false;
  }

  static cancel() {
    // this is used to cancel from webview
    CLL.onCancel();
    columnLineage(CllEvents.CANCEL);
    const event = new CustomEvent("cll_cancelled", { detail: undefined });
    document.dispatchEvent(event);
  }

  static start() {
    CLL.inProgress = true;
    CLL.isCancelled = false;
    CLL.linkCount = 0;
    columnLineage(CllEvents.START);
    showInfoNotification("Computing column-level lineage…");
  }

  static end() {
    CLL.inProgress = false;
    columnLineage(CllEvents.END);
    telemetryEvents({
      id: "columnLineageNumLinks",
      params: { num: CLL.linkCount },
    });
    CLL.linkCount = 0;
  }

  static addLinks(n: number) {
    CLL.linkCount += n;
  }

  static showCllInProgressMsg() {
    showInfoNotification(
      "Column lineage is in progress. Either wait for it to complete or cancel the current one."
    );
  }
}
